module.exports = __webpack_public_path__ + "assets/img/hero_7.da77eb73.png";